module.exports = __webpack_public_path__ + "static/media/fi.d26542b4.svg";